import { GzAccessDataProtectionWebComponent } from './component/AccessDataProtectionWebComponent';

export { GzAccessDataProtectionWebComponent };
